<div class="portfolio-box stock-allocation-box">
  <h2 class="ui-headline">{{ 'new_strategy.portfolio_screen.stockAllocation.title' | translate }}</h2>
  <p>
    {{ 'new_strategy.portfolio_screen.stockAllocation.p' | translate }}
  </p>
  <div class="stock-allocation-chart-wrapper">
    <div class="stock-allocation-tabs">
      <div class="stock-allocation-tab" (click)="switchTab('sector')" [ngClass]="{ active: activeTab === 'sector' }">
        {{ 'new_strategy.portfolio_screen.stockAllocation.sector.title' | translate }}
      </div>
      <div class="stock-allocation-tab" (click)="switchTab('currency')" [ngClass]="{ active: activeTab === 'currency' }">
        {{ 'new_strategy.portfolio_screen.stockAllocation.currency.title' | translate }}
      </div>
    </div>
    <div class="skeleton-wrapper" *ngIf="!stockAllocationSector; else showCharts">
      <div class="chart skeleton"></div>
      <div class="list-holder">
        <div class="title skeleton" *ngFor="let load of [].constructor(4)"></div>
      </div>
    </div>
    <ng-template #showCharts>
      <div class="stock-allocation-content-holder">
        <div class="stock-allocation-content">
          <div class="stock-allocation-chart-holder">
            <div class="stock-allocation-chart" [class.inactive]="!showMore" (click)="showMore = true">
              <app-strategy-donut-chart
                [config]="donutChartConfig"
                [selected]="selectedIndex"
                [data]="showMore ? fullList : shortList"
                (updateSelected)="setSelected($event)"
              ></app-strategy-donut-chart>
            </div>
            <div class="stock-allocation-companies">
              <ng-container *ngIf="selectedRandomCompanies.length; else showSectorPlaceholder">
                <div *ngFor="let company of selectedRandomCompanies">
                  {{ company.name }}
                </div>
              </ng-container>
              <ng-template #showSectorPlaceholder>
                {{ 'new_strategy.portfolio_screen.stockAllocation.' + activeTab + '.placeholder' | translate }}
              </ng-template>
            </div>
          </div>
          <div class="stock-allocation-short-list" [ngClass]="{ 'hide-item': showMore }" (click)="showMore = true">
            <div *ngFor="let item of shortList; let i = index" class="stock-allocation-short-list-item">
              <div>
                <div class="circle" [ngStyle]="{ 'background-color': item.color }"></div>
                <div>
                  {{ 'new_strategy.portfolio_screen.stockAllocation.' + activeTab + '.' + item.key | translate }}
                </div>
              </div>
              <div>{{ item.value * 100 | translatePercent: customer?.language }}</div>
            </div>
          </div>
          <div class="stock-allocation-list" [ngClass]="{ 'hide-item': !showMore }">
            <ul>
              <li
                *ngFor="let item of fullList; let i = index"
                (click)="setSelected(item.id)"
                [ngClass]="{ 'un-selected': selectedIndex !== null && item.id !== selectedIndex }"
              >
                <div>
                  <div class="circle" [ngStyle]="{ 'background-color': item.color }"></div>
                  <div>
                    {{ 'new_strategy.portfolio_screen.stockAllocation.' + activeTab + '.' + item.key | translate }}
                  </div>
                </div>
                <div>{{ item.value * 100 | translatePercent: customer?.language }}</div>
              </li>
            </ul>
            <div class="total-row">
              <div>{{ 'performance.overview.alltime_mob' | translate }}</div>
              <div>{{ 100 | translatePercent: customer?.language }}</div>
            </div>
          </div>
          <div
            class="stock-allocation-companies mobile"
            [ngClass]="{ 'hide-item': !showMore, 'list-view': selectedRandomCompanies.length }"
          >
            <ng-container *ngIf="selectedRandomCompanies.length; else showSectorPlaceholder">
              <div *ngFor="let company of selectedRandomCompanies">
                {{ company.name }}
              </div>
            </ng-container>
            <ng-template #showSectorPlaceholder>
              {{ 'new_strategy.portfolio_screen.stockAllocation.' + activeTab + '.placeholder' | translate }}
            </ng-template>
          </div>
          <div class="show-more" (click)="switchShowMore()">
            {{ (!showMore ? 'strategy.show_more' : 'strategy.show_less') | translate }}
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
